/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendBuyerRepliedToSupplierChatMutationVariables = Exact<{
  buyingCompanyId: string;
  supplyingCompanyId: string;
  buyerName: string;
}>;


export type SendBuyerRepliedToSupplierChatMutation = { sendBuyerRepliedToSupplierChat: { success: boolean } | null };


export const SendBuyerRepliedToSupplierChatDocument = /*#__PURE__*/ gql`
    mutation sendBuyerRepliedToSupplierChat($buyingCompanyId: uuid!, $supplyingCompanyId: uuid!, $buyerName: String!) {
  sendBuyerRepliedToSupplierChat(
    buyerCompanyId: $buyingCompanyId
    buyerName: $buyerName
    supplierCompanyId: $supplyingCompanyId
  ) {
    success
  }
}
    `;
export type SendBuyerRepliedToSupplierChatMutationFn = Apollo.MutationFunction<SendBuyerRepliedToSupplierChatMutation, SendBuyerRepliedToSupplierChatMutationVariables>;

/**
 * __useSendBuyerRepliedToSupplierChatMutation__
 *
 * To run a mutation, you first call `useSendBuyerRepliedToSupplierChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBuyerRepliedToSupplierChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBuyerRepliedToSupplierChatMutation, { data, loading, error }] = useSendBuyerRepliedToSupplierChatMutation({
 *   variables: {
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *      supplyingCompanyId: // value for 'supplyingCompanyId'
 *      buyerName: // value for 'buyerName'
 *   },
 * });
 */
export function useSendBuyerRepliedToSupplierChatMutation(baseOptions?: Apollo.MutationHookOptions<SendBuyerRepliedToSupplierChatMutation, SendBuyerRepliedToSupplierChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBuyerRepliedToSupplierChatMutation, SendBuyerRepliedToSupplierChatMutationVariables>(SendBuyerRepliedToSupplierChatDocument, options);
      }
export type SendBuyerRepliedToSupplierChatMutationHookResult = ReturnType<typeof useSendBuyerRepliedToSupplierChatMutation>;
export type SendBuyerRepliedToSupplierChatMutationResult = Apollo.MutationResult<SendBuyerRepliedToSupplierChatMutation>;
export type SendBuyerRepliedToSupplierChatMutationOptions = Apollo.BaseMutationOptions<SendBuyerRepliedToSupplierChatMutation, SendBuyerRepliedToSupplierChatMutationVariables>;